import { Component, OnInit, Input } from '@angular/core';

// ------------------------------------------------------
export interface ICheckboxControl {
  loading: boolean;
  disabled: boolean;
  error: string;
}

@Component({
  selector: 'smartcheckbox',
  template: require('./smartcheckbox.component.pug'),
  styles: [require('./smartcheckbox.component.css').toString()],
})
export class SmartCheckboxComponent implements OnInit {
  @Input('checked')
  checked: boolean;

  @Input('title')
  title: string;
  @Input()
  label: string = null;
  @Input('data')
  data: any;
  @Input('onclick')
  onclick: onSmartCheckboxCallback;
  @Input('controller')
  controller: ICheckboxControl;
  @Input('color')
  color: boolean = true;
  @Input('extraclass')
  extraclass: string = '';
  @Input('compact')
  compact: boolean = false;
  @Input('disabled')
  disabled: boolean = false;
  @Input()
  useToggle: boolean = false;

  error: boolean = false;
  loading: boolean = false;

  // -------------------------------------------------------------------
  constructor() {}

  // -------------------------------------------------------------------
  ngOnInit() {
    /*
    console.log('title');
    console.log(this.title);
    console.log('data');
    console.log(this.data);
    */
  }

  // -------------------------------------------------------------------
  onSuccess() {
    this.loading = false;
    //console.log('onSuccess!');
  }

  // -------------------------------------------------------------------
  onFailure() {
    this.error = true;
    this.loading = false;
    //console.log('onFailure!');
  }

  called = false;

  // -------------------------------------------------------------------
  clicked() {
    if (this.loading) {
      return; // don't accept clicks in transition state
    }

    this.called = true;
    this.error = false;
    this.loading = true;

    this.onclick(
      this.data,
      this.onSuccess.bind(this),
      this.onFailure.bind(this),
    );
  }
}
